var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { AppHttpClient } from 'common/core/http/app-http-client.service';
import * as i0 from "@angular/core";
import * as i1 from "../../../common/core/http/app-http-client.service";
var SharesApiService = /** @class */ (function () {
    function SharesApiService(http) {
        this.http = http;
    }
    /**
     * Update users and permissions on specified entries.
     */
    SharesApiService.prototype.updateUsers = function (params) {
        return this.http.put('drive/shares/update-users', params);
    };
    /**
     * Attach specified users to entries.
     */
    SharesApiService.prototype.shareEntries = function (params) {
        return this.http.post('drive/shares/add-users', __assign({}, params, { entries: params.entries.map(function (entry) { return entry.id; }) }));
    };
    /**
     * Detach specified user from entries.
     */
    SharesApiService.prototype.detachUser = function (userId, entryIds) {
        return this.http.delete('drive/shares/remove-user/' + userId, { entries: entryIds });
    };
    SharesApiService.ngInjectableDef = i0.defineInjectable({ factory: function SharesApiService_Factory() { return new SharesApiService(i0.inject(i1.AppHttpClient)); }, token: SharesApiService, providedIn: "root" });
    return SharesApiService;
}());
export { SharesApiService };
